import { Form, Input } from 'antd';
import { InverterApi } from 'api/InverterApi';
import { useAppSelector } from 'app/hooks';
import { selectInverterItemSidebar } from 'components/Common/Sidebar/sidebarSlice';
import { objectTimes } from 'models';
import { useEffect, useState } from 'react';
import { customNumberToTimes } from 'utils/common';

type inputTimesProps = {
  item: any;
};

export default function InputTimes(props: inputTimesProps) {
  const { item } = props;
  const inverterId = useAppSelector(selectInverterItemSidebar);
  const [initialValue, setInitialValue] = useState<objectTimes | null>(null);
  useEffect(() => {
    if (item) {
      (async () => {
        const response: any = await InverterApi.fetchStatisticByDevice({
          id: inverterId,
          text: item.key,
        });
        setInitialValue(
          response[item.key][0].value !== null
            ? customNumberToTimes(response[item.key][0].value)
            : customNumberToTimes(0)
        );
      })();
    }
  }, [item]);

  return (
    <>
      {initialValue !== null && (
        <Form.Item
          label={item.label}
          style={{
            marginBottom: 0,
          }}
        >
          <Form.Item
            name="day"
            initialValue={initialValue.day}
            rules={[
              {
                validator: (_, value) => {
                  const integer_reg = /^(0|[1-9][0-9]*)$/;
                  if (integer_reg.test(value)) {
                    //   if (eval(item.condition.replace(/value/g, value))) {
                    return Promise.resolve();
                    //   } else {
                    //     return Promise.reject(
                    //       new Error(`input number out of range ${item.condition_label}`)
                    //     );
                    //   }
                  } else {
                    return Promise.reject(new Error(`input number integer`));
                  }
                },
              },
            ]}
            style={{
              display: 'inline-block',
              width: 'calc((100% /3) - 24px)',
            }}
          >
            <Input placeholder="Input days" addonAfter={'d'} />
          </Form.Item>
          <span
            style={{ width: '24px', lineHeight: '32px', textAlign: 'center', marginLeft: '8px' }}
          >
            :
          </span>
          <Form.Item
            name="hours"
            initialValue={initialValue.hours}
            rules={[
              {
                validator: (_, value) => {
                  const integer_reg = /^(0|[1-9][0-9]*)$/;
                  if (integer_reg.test(value)) {
                    //   if (eval(item.condition.replace(/value/g, value))) {
                    return Promise.resolve();
                    //   } else {
                    //     return Promise.reject(
                    //       new Error(`input number out of range ${item.condition_label}`)
                    //     );
                    //   }
                  } else {
                    return Promise.reject(new Error(`input number integer`));
                  }
                },
              },
            ]}
            style={{
              display: 'inline-block',
              width: 'calc((100% /3) - 24px)',
              margin: '0 8px',
            }}
          >
            <Input placeholder="Input hours" addonAfter={'h'} />
          </Form.Item>
          <span style={{ width: '24px', lineHeight: '32px', textAlign: 'center' }}>:</span>
          <Form.Item
            name="minute"
            initialValue={initialValue.minute}
            rules={[
              {
                validator: (_, value) => {
                  const integer_reg = /^(0|[1-9][0-9]*)$/;
                  if (integer_reg.test(value)) {
                    //   if (eval(item.condition.replace(/value/g, value))) {
                    return Promise.resolve();
                    //   } else {
                    //     return Promise.reject(
                    //       new Error(`input number out of range ${item.condition_label}`)
                    //     );
                    //   }
                  } else {
                    return Promise.reject(new Error(`input number integer`));
                  }
                },
              },
            ]}
            style={{
              display: 'inline-block',
              width: 'calc((100% /3) - 24px)',
              margin: '0 8px',
            }}
          >
            <Input placeholder="Input minute" addonAfter={'m'} />
          </Form.Item>
        </Form.Item>
      )}
    </>
  );
}
